import React, {useContext} from 'react';
import {AccordionContext, useAccordionButton} from 'react-bootstrap';
import {theme} from '../../../../styles/darkTheme';
import {Container, Title} from './styles';
import Icon from '../../Icon';
import ArrowDown from '../../../../assets/icons/ArrowDown.svg';
import ArrowUp from '../../../../assets/icons/ArrowUp.svg';

interface Props {
  children: React.ReactNode;
  eventKey: string;
  callback?: (eventKey: string) => any;
}

const Header: React.FC<Props> = ({children, eventKey, callback}) => {
  const {activeEventKey} = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <Container onClick={decoratedOnClick}>
      <Title theme={theme}>{children}</Title>
      <Icon src={isCurrentEventKey ? ArrowUp : ArrowDown} size={14} />
    </Container>
  );
};

export default Header;
